import { ICreditsState } from './types';

export const SLICE_NAMESPACE = 'credits';

export const creditsInitialState: ICreditsState = {
  creditLimits: [],
  loading: true,
  error: null,
};
